import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import flatten from 'notebook/tables/excess/util/flatten';
import {formatTypedValue} from 'notebook/tables/typed-values/DataTypes';
import {TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';

export default {
  name: 'CONCATENATE',
  shortDescription: 'Appends strings to one another.',
  category: FunctionCategory.TEXT,
  description: 'Appends strings to one another.',
  params: [
    {
      name: 'value',
      type: ArgType.any,
      description: 'The initial string.',
    },
  ],
  repeatableLastParamType: ArgType.any,
  repeatableLastParamDescription: 'More strings to append in sequence.',

  processArgValues: (argValues: Array<TypedValue | null>, context?): Array<string | undefined> =>
    // Note that `argValue` can be null in the case of optional arguments.
    argValues.map((argValue) =>
      argValue == null ? undefined : formatTypedValue(argValue, {}, '', undefined, context)
    ),

  eval: (...values: Array<string | undefined>): string => flatten(values).join(''),
} satisfies EvaluablePrimitiveSpreadsheetFunction;
